
    <div *ngIf="control.errors && (submitted || control.dirty || control.touched)" class=" text-danger">
      <div *ngFor="let error of (control.errors | errorMessages)">
         {{ error }}
      </div>
    </div>
  


// WEBPACK FOOTER //
// ./src/app/shared/error-label.component.ts.ErrorLabelComponent.html